import { Clipboard } from '@capacitor/clipboard';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { isCapacitor } from '../utils/platform';
import { createLogger } from '../services/Debug';
// ================== CLIPBOARD FUNCTIONS ==================
export const writeToClipboard = async (text) => {
  const log = createLogger('writeToClipboard');
  try {
    if (isCapacitor) {
      await Clipboard.write({
        string: text
      });
    } else {
      await navigator.clipboard.writeText(text);
    }
    return true;
  } catch (error) {
    log.error('Error writing to clipboard:', error);
    return false;
  }
};



// ================== HAPTIC FEEDBACK FUNCTIONS ==================
export async function tripleImpact() {
  if (!isCapacitor) {return;}
  // Un impact léger
  await Haptics.impact({ style: ImpactStyle.Light });
  await wait(100);

  // Un impact moyen
  await Haptics.impact({ style: ImpactStyle.Medium });
  await wait(100);

  // Un impact lourd
  await Haptics.impact({ style: ImpactStyle.Heavy });
}

export async function doubleLongTap() {
  if (!isCapacitor) {return;}
  // Première longue vibration (300 ms)
  await Haptics.vibrate({ duration: 300 });
  
  // Pause de 200 ms
  await wait(200);
  
  // Deuxième longue vibration (300 ms)
  await Haptics.vibrate({ duration: 300 });
}

export function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}